const supportedLocales = {
    en: 'English',
    de: "DE",
    it: 'IT',
    fr: 'FR'
};

export default supportedLocales;

export function getSupportedLocales() {
    let annotatedLocales = [];

    for (const code of Object.keys(supportedLocales)) {
        annotatedLocales.push({
            code,
            name: supportedLocales[code]
        });
    }
    return annotatedLocales;
}